import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import { FormattedMessage } from 'component-utilities/intl';

import styles from './AppHeader.scss';

export default function AccountInfoDisplay({ user: { accountTitle } }) {
    return (
        <div className={styles['dropdown-content']}>
            <span className={styles['account-name']}>
                <FormattedMessage id="components.app_header.account_info_display.account_name" />
            </span>
            <span className={styles['account-title']}>
                {accountTitle}
            </span>
        </div>
    );
}

AccountInfoDisplay.displayName = displayName('AppHeader/AccountInfoDisplay');

AccountInfoDisplay.propTypes = {
    user: PropTypes.shape({
        accountTitle: PropTypes.node.isRequired,
    }).isRequired,
};
